import { useEffect, useRef } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Konfirmasi aman: fokus awal selalu di Batal (safe default), fokus kembali
// ke pemicu saat dialog ditutup (AlertDialog tanpa Trigger tak melakukannya
// sendiri). Untuk CONSEQUENCE=3.
export default function ConfirmDialog({
  open, onOpenChange, title, description, confirmLabel = "Ya, lanjutkan",
  onConfirm, pending = false, danger = true, testId = "confirm-dialog",
}) {
  const cancelRef = useRef(null);
  const openerRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    openerRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    return () => {
      const target = openerRef.current;
      openerRef.current = null;
      setTimeout(() => {
        if (target && document.contains(target)) target.focus({ preventScroll: true });
      }, 0);
    };
  }, [open ]);
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid={testId}
        onOpenAutoFocus={(e) => { e.preventDefault(); cancelRef.current?.focus(); }}
        className="border-white/10 bg-zinc-900 text-zinc-100"
      >
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && <AlertDialogDescription className="text-zinc-400">{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            ref={cancelRef}
            data-testid={`${testId}-cancel`}
            className="h-11 rounded-full border-white/15 bg-transparent text-zinc-200 hover:bg-white/10 hover:text-white"
          >
            Batal
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testId}-confirm`}
            disabled={pending}
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            className={`h-11 rounded-full px-5 font-semibold ${
              danger
                ? "bg-rose-500 text-white hover:bg-rose-400"
                : "bg-[#0069DB] text-white hover:bg-[#0058B6]"
            }`}
          >
            {pending ? "Memproses…" : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
